/**
 * Tiny pub/sub store for the current page's share metadata. `<Seo>` publishes
 * on every page render, and the sitewide share bars subscribe, so pages never
 * need to pass their title/description twice.
 */
export interface ShareMeta {
  title: string;
  description?: string;
  noindex?: boolean;
  /** The page path the meta belongs to, so consumers can ignore stale meta during route transitions. */
  path: string;
}

let current: ShareMeta | null = null;
const listeners = new Set<() => void>();

export function setShareMeta(meta: ShareMeta) {
  if (
    current &&
    current.title === meta.title &&
    current.description === meta.description &&
    current.noindex === meta.noindex &&
    current.path === meta.path
  ) {
    return;
  }
  current = meta;
  listeners.forEach((l) => l());
}

export function getShareMeta(): ShareMeta | null {
  return current;
}

export function subscribeShareMeta(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
